module.exports = __webpack_public_path__ + "media/images/cut_v-33e16b7cac425d9fa7c1d6c8b2a175ae.png";